import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { useStateValue } from '../../../state'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const DevKeyForm = ({organization, setOrganization, toggle}) => {
  const [currentState, dispatch] = useStateValue()
  const devKey = organization.devKey

  const [appId, updateAppId] = useState(devKey ? devKey.appId : '')
  const [appKey, updateAppKey] = useState(devKey ? devKey.appKey : '')

  const [showRequiredAppId, setShowRequiredAppId] = useState(false)
  const [showRequiredAppKey, setShowRequiredAppKey] = useState(false)

  const handleAppIdChange = e => {
    updateAppId(e.target.value)
  }

  const handleAppKeyChange = e => {
    updateAppKey(e.target.value)
  }

  const addDevKey = async () => {
    if (!appId || !appKey) {
      setShowRequiredAppId(appId === '')
      setShowRequiredAppKey(appKey === '')
    }

    try {
      const resp = await client.post(endpoints.addDevKey({ orgId: organization.id }), {
        ...devKey,
        appId: appId,
        appKey: appKey,
      })
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully saved the Dev Key."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
        timeout: 3000,
      })
      toggle(false)
      setOrganization(resp.data.organization)
      // Updates the label in OrganizationAttributes.js
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      let errMsg = "There was an error trying to save the Dev Key."
      if (err.response.data.error) {
        errMsg = err.response.data.error
      }
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={errMsg}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        timeout: 15000,
      })
    }
  }

  const deleteDevKey = async () => {

    try {
      const resp = await client.delete(endpoints.deleteDevKey({ orgId: organization.id }))
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully deleted the Dev Key."
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-trash fa-3x" />}
          />
        ),
        timeout: 3000,
      })
      toggle(false)
      setOrganization(resp.data.organization)
      // Updates the label in OrganizationAttributes.js
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      let errMsg = "There was an error trying to delete the Dev Key."
      if (err.response.data.error) {
        errMsg = err.response.data.error
      }
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={errMsg}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        timeout: 15000,
      })
    }

  }

  const requiredAppId = showRequiredAppId && <span> Required</span>
  const requiredAppKey = showRequiredAppKey && <span> Required</span>

  const addBtn = devKey ? (
    <div className="d-flex justify-content-between">
      <div
        className="btn btn-success btn-myed btn-warning-myed"
        onClick={() => addDevKey()}
      >
        <div className="far fa-cog fa-fw mr-2" /> Update
      </div>
      <div
        className="btn btn-success btn-myed btn-danger-myed"
        onClick={() => deleteDevKey()}
      >
        <div className="far fa-times fa-fw mr-2" /> Remove
      </div>
    </div>
  ) : (
      <div
        className="btn btn-success btn-myed btn-success-myed"
        onClick={() => addDevKey()}
      >
        <div className="far fa-plus fa-fw mr-2" /> Add
      </div>
  )


  return (
    <Fragment>
      <FormGroup controlId="appId">
        <ControlLabel>App ID<span className='text-orange'>{requiredAppId}*</span></ControlLabel>
        <FormControl type="text" onChange={handleAppIdChange} value={appId} />
      </FormGroup>
      <FormGroup controlId="appKey">
        <ControlLabel>App Key<span className='text-orange'>{requiredAppKey}*</span></ControlLabel>
        <FormControl type="text" onChange={handleAppKeyChange} value={appKey} />
      </FormGroup>
      {addBtn}
    </Fragment>
  )
}

DevKeyForm.propTypes = {
  organization: PropTypes.object.isRequired,
  setOrganization: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DevKeyForm
